import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { createLostDealSchema, defaultFormValues } from './form.schema';

import type { TLostDealFormInput, TLostDealFormState } from './form.schema';

export const useLostDealForm = () => {
    const { t } = useTranslation();
    const lostDealSchema = createLostDealSchema(t);
    const {
        control,
        handleSubmit,
        reset,
        formState: { isSubmitting, isValid },
    } = useForm<TLostDealFormInput, unknown, TLostDealFormState>({
        resolver: zodResolver(lostDealSchema),
        defaultValues: defaultFormValues,
        mode: 'onChange',
    });

    const resetForm = () => {
        reset(defaultFormValues);
    };

    return {
        control,
        handleSubmit,
        isSubmitting,
        isValid,
        resetForm,
    };
};
